import { ServiceJourney } from "api-client/models/ServiceJourney";

export enum ACTIONS {
    GET_RECRUITMENT_JOURNEY_REQUEST = "RECRUITMENT_JOURNEY/GET_RECRUITMENT_JOURNEY_REQUEST",
    GET_RECRUITMENT_JOURNEY_SUCCESS = "RECRUITMENT_JOURNEY/GET_RECRUITMENT_JOURNEY_SUCCESS",
    GET_RECRUITMENT_JOURNEY_FAILURE = "RECRUITMENT_JOURNEY/GET_RECRUITMENT_JOURNEY_FAILURE",
}

interface GetRecruitmentJourneyRequest {
    type: ACTIONS.GET_RECRUITMENT_JOURNEY_REQUEST;
}

interface GetRecruitmentJourneySuccess {
    type: ACTIONS.GET_RECRUITMENT_JOURNEY_SUCCESS;
    payload: ServiceJourney;
}

interface GetRecruitmentJourneyFailure {
    type: ACTIONS.GET_RECRUITMENT_JOURNEY_FAILURE;
}

export type ActionType =
    | GetRecruitmentJourneyRequest
    | GetRecruitmentJourneySuccess
    | GetRecruitmentJourneyFailure;
